import request from '../utils/request';

export async function getShopSummary(shop, start, end) {
  return await request(`analysis/shoporder?shop=${shop}&start=${start}&end=${end}`, 'get');
}